import * as R from 'ramda'

export type M =
    | 'BpsUser'
    | 'CreatedFrom'
    | 'CreatedTo'
    | 'Status'

export function all(): M[] {
    return [
        'BpsUser',
        'CreatedFrom',
        'CreatedTo',
        'Status',
    ]
}

export function label(filterType: M): string {
    switch (filterType) {
        case 'BpsUser':
            return 'Benutzer'
        case 'CreatedFrom':
            return 'Datum von'
        case 'CreatedTo':
            return 'Datum bis'
        case 'Status':
            return 'Status'
    }
}

export function sort(filterTypes: M[]): M[] {
    return R.sortBy(label, filterTypes)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/PrismaRequestFiltering/Model/PrismaRequestFilterType.ts